import { render, staticRenderFns } from "./fbHot.vue?vue&type=template&id=2fa17d0e"
import script from "./fbHot.vue?vue&type=script&lang=js"
export * from "./fbHot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports